import { render, staticRenderFns } from "./SerialNumberConfig.vue?vue&type=template&id=10d0fbf6&scoped=true"
import script from "./SerialNumberConfig.vue?vue&type=script&lang=js"
export * from "./SerialNumberConfig.vue?vue&type=script&lang=js"
import style0 from "./SerialNumberConfig.vue?vue&type=style&index=0&id=10d0fbf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d0fbf6",
  null
  
)

export default component.exports